import { Component, OnInit, ViewChild } from "@angular/core";
import { MatCheckboxChange } from "@angular/material/checkbox";
import { MatPaginator } from "@angular/material/paginator";
import { MatSnackBarConfig, MatSnackBar } from "@angular/material/snack-bar";
import { MatSort } from "@angular/material/sort";
import { MatTableDataSource } from "@angular/material/table";
import { DataSharingService } from "../../AuthGuard/DataSharingService";
import { MasterService } from "../../Shared/app.Masters.Service";
import { RequestModel } from "../../Shared/Models/app.MasterRequestModel";
import { SnackbarComponent } from "../../snackbar/snackbar.component";
import { Router } from "@angular/router";
import { LosService } from "../../_LOS/services/los.service";
import * as moment from "moment";
import { LmsService } from "../../_Lms/services/lms.service";
declare var $: any;
import { DialogService } from "../../Shared/dialog.service";

@Component({
  selector: "app-asset-info-master",
  templateUrl: "./asset-info-master.component.html",
  styleUrls: ["./asset-info-master.component.scss"],
})
export class AssetInfoMasterComponent implements OnInit {
  private data: any;
  private _MasterService;
  showSpinner: boolean = false;
  private _LmsService;
  RequestModel: RequestModel = new RequestModel();
  ReportingManagerRequestModel: RequestModel = new RequestModel();
  CopyEmployeeRequestModel: RequestModel = new RequestModel();
  EmployeeProcessForCopyRequestModel: RequestModel = new RequestModel();
  SaveEmployeeDataRequestModel: RequestModel = new RequestModel();
  SaveEmployeeProfileRequestModel: RequestModel = new RequestModel();
  EmpDeleteAssBranchRequestModel: RequestModel = new RequestModel();
  EmpDeleteAssProcessRequestModel: RequestModel = new RequestModel();

  loading: boolean = false;
  CurrentDate: any = new Date();
  // register new role
  Manufacture: any = "";
  CategoryData: any;
  JsonData: any[] = [];
  EmployeeId: any = 0;
  // save data array
  SelectedLoanProcessData: any = [];
  SelectedBranchesData: any = [];
  // bind data
  BranchesList: any = [];
  // copy employee
  CopyEmployeeId: any = "";
  applicationId: any = 95;
  dataCustomerSource: any;
  Id: number;
  saveBtn: boolean = true;
  updateBtn: boolean = false;

  displayedCustomerColumns: string[] = [
    "Number",
    "Manufacture",
    "Categories",
    "Action",
  ];

  selectAll: boolean = false;
  CategoryIds: any;

  constructor(
    private _Route: Router,
    private dataSharingService: DataSharingService,
    public snackBar: MatSnackBar,
    private MasterService: MasterService,
    private losService: LosService,
    private LmsService: LmsService,
    private dialog: DialogService
  ) {
    this._MasterService = MasterService;
    this._LmsService = LmsService;
    this.data = JSON.parse(sessionStorage.getItem("currentUser"));
  }

  configSuccess: MatSnackBarConfig = {
    panelClass: "style-success",
    duration: 5000,
    horizontalPosition: "right",
    verticalPosition: "top",
  };

  ngOnInit() {
    this.dataSharingService.HeaderTitle.next("Asset Info master");
    // this._MasterService.GetRoleForDropdown().subscribe((result) => {
    //   this.RolesDropdownData = JSON.parse(JSON.stringify(result));
    // });
    this.LMS_GetVehicleMaster();
    this.LMS_GetAssetInfoMaster();
  }

  LMS_GetAssetInfoMaster() {
    this.showSpinner = true;
    this._LmsService.Get_Lms_AssetInfo().subscribe((response) => {
      console.log("Get_Lms_AssetInfo", response);
      if (response.length > 0) {
        this.dataCustomerSource = new MatTableDataSource(response);
        this.JsonData = JSON.parse(JSON.stringify(response));
      }
    });
  }

  exportexcelNew(): void {
    const uri = "data:application/vnd.ms-excel;base64,";
    const template =
      '<html xmlns:o="urn:schemas-microsoft-com:office:office" xmlns:x="urn:schemas-microsoft-com:office:excel" xmlns="http://www.w3.org/TR/REC-html40"><head><!--[if gte mso 9]><xml><x:ExcelWorkbook><x:ExcelWorksheets><x:ExcelWorksheet><x:Name>{worksheet}</x:Name><x:WorksheetOptions><x:DisplayGridlines/></x:WorksheetOptions></x:ExcelWorksheet></x:ExcelWorksheets></x:ExcelWorkbook></xml><![endif]--></head><body><table>{table}</table></body></html>';
    const base64 = (s: string): string =>
      window.btoa(unescape(encodeURIComponent(s)));
    const format = (s: string, c: { [key: string]: string }): string =>
      s.replace(/{(\w+)}/g, (m, p) => c[p]);

    const table = document.getElementById(
      "export_vehicle_manufacture"
    ) as HTMLTableElement;
    const worksheetName = "VEHICLE MANUFACTURE"; // Set the desired worksheet name here
    const ctx = { worksheet: worksheetName, table: table.innerHTML };
    const downloadLink = document.createElement("a");

    // Generate the data URI for the Excel file
    downloadLink.href = uri + base64(format(template, ctx));

    // Set the file name for the download
    downloadLink.download = worksheetName + ".xls";

    // Trigger the download
    downloadLink.click();
  }

  onSaveManufacture() {
    var CategoryIds = "";
    this.CategoryData.forEach((obj: any) => {
      if (obj.selected == true) {
        if (CategoryIds == "") {
          CategoryIds = obj.Int_Id + "";
        } else {
          CategoryIds = CategoryIds + "," + obj.Int_Id;
        }
      }
    });
    if (CategoryIds == "") {
      this.snackBar.openFromComponent(SnackbarComponent, {
        data: "Please Select Atleast one Category.",
        ...this.configSuccess,
      });
    } else {
      this.onCloseModal();
      let saveAreaDetail = {
        Int_Id: 0,
        IsActive: 1,
        Manufacture: this.Manufacture,
        CategoryIds: CategoryIds,
      };
      this._LmsService
        .Save_Lms_AssetInfo(saveAreaDetail)
        .subscribe((response) => {
          if (response[0].CODE == 0) {
            this.LMS_GetAssetInfoMaster();
            this.snackBar.openFromComponent(SnackbarComponent, {
              data: response[0].MSG,
              ...this.configSuccess,
            });
          } else {
            this.snackBar.openFromComponent(SnackbarComponent, {
              data: response[0].MSG,
              ...this.configSuccess,
            });
          }
        });
    }
  }

  updateSelectedCategories() {
    const selectedItems = this.CategoryData.filter(
      (obj: any) => obj.selected
    ).map((obj: any) => obj.Int_Id.toString());
    this.CategoryIds =
      selectedItems.length === 1
        ? String(selectedItems[0])
        : selectedItems.join(",");

    console.log("CategoryIds:", this.CategoryIds, typeof this.CategoryIds);
  }

  removeAssetInfo(data: any) {
    this.dialog
      .openConfirmDialog(
        `Are you sure you want to delete this Asset Info ${data.Manufacture}.`
      )
      .afterClosed()
      .subscribe((dialogResult) => {
        if (dialogResult == false) {
          return;
        } else {
          this.showSpinner = true;
          this._LmsService
            .Delete_Lms_AssetInfoMaster({ Int_Id: data.Int_Id })
            .subscribe((res: any) => {
              this.showSpinner = false;
              if (res[0].CODE >= 0) {
                this.snackBar.openFromComponent(SnackbarComponent, {
                  data: res[0].MSG,
                  ...this.configSuccess,
                });
                this.LMS_GetAssetInfoMaster();
              } else {
                this.snackBar.openFromComponent(SnackbarComponent, {
                  data: res[0].MSG,
                  ...this.configSuccess,
                });
              }
            });
        }
      });
  }

  editAssetInfo(data: any) {
    $("#addVehiclemanufactureModel").modal("show");
    $("#addVehiclemanufactureModel").css("z-index", "1050");
    if (data.CategoryIds != null && data.CategoryIds != "") {
      const selectedIds = data.CategoryIds.split(",").map((id) => id.trim());
      this.CategoryData.forEach((obj: any) => {
        obj.selected = selectedIds.includes(String(obj.Int_Id));
      });
      console.log("this.CategoryData", selectedIds);
    } else {
      this.CategoryData.forEach((obj: any) => {
        obj.selected = false;
      });
    }
    this.Manufacture = data.Manufacture.trim();
    this.Id = data.Int_Id;
    this.saveBtn = false;
    this.updateBtn = true;
  }

  toggleSelectAll() {
    let allCategoryData = [...this.CategoryData];

    if (this.selectAll) {
      this.CategoryData = allCategoryData.map((item) => ({
        ...item,
        selected: true,
      }));
    } else {
      this.CategoryData.forEach((item) => (item.selected = false));
    }

    console.log("CategoryData:", this.CategoryData);
  }

  // Check if all checkboxes are selected and update "Select All" checkbox accordingly
  checkIfAllSelected() {
    this.selectAll = this.CategoryData.every((item) => item.selected);
  }

  UpdateAssetInfo() {
    var CategoryIds = "";

    this.CategoryData.forEach((obj: any) => {
      if (obj.selected) {
        if (CategoryIds == "") {
          CategoryIds = obj.Int_Id.toString(); // Ensure it's a string
        } else {
          CategoryIds = CategoryIds + "," + obj.Int_Id.toString();
        }
      }
    });

    console.log("CategoryIds:", this.CategoryIds, typeof this.CategoryIds);
    if (CategoryIds == "") {
      this.snackBar.openFromComponent(SnackbarComponent, {
        data: "Please Select Atleast one Category.",
        ...this.configSuccess,
      });
    } else {
      this.onCloseModal();
      this.saveBtn = true;
      this.updateBtn = false;
      console.log("this.areaId", this.Id);
      let updateAreaDetail = {
        Int_Id: this.Id,
        IsActive: 1,
        Manufacture: this.Manufacture,
        CategoryIds: CategoryIds,
      };
      this._LmsService
        .Save_Lms_AssetInfo(updateAreaDetail)
        .subscribe((response) => {
          if (response[0].CODE == 0) {
            this.Id = 0;
            this.snackBar.openFromComponent(SnackbarComponent, {
              data: response[0].MSG,
              ...this.configSuccess,
            });
            this.LMS_GetAssetInfoMaster();
          } else {
            this.snackBar.openFromComponent(SnackbarComponent, {
              data: response[0].MSG,
              ...this.configSuccess,
            });
          }
        });
    }
  }

  applyFilter(filterValue: string) {
    this.dataCustomerSource.filter = filterValue.trim().toLowerCase();
  }

  openAddVehiclemanufacture() {
    this.CategoryData.forEach((obj: any) => {
      obj.selected = false;
    });
    $("#addVehiclemanufactureModel").modal("show");
    $("#addVehiclemanufactureModel").css("z-index", "1050");
  }

  onCloseModal() {
    $("#addVehiclemanufactureModel").modal("hide");
  }
  LMS_GetVehicleMaster() {
    this._LmsService.Get_Lms_VehicleMaster().subscribe((response) => {
      if (response.length > 0) {
        console.log(response);
        response.forEach((obj: any) => {
          obj.selected = false;
        });
        this.CategoryData = JSON.parse(JSON.stringify(response));
      }
    });
  }
}
